/**
 * Yönetici Kayıt — DEVRE DIŞI (S6 admin model değişikliği)
 *
 * Public signup kapatıldı. Hesaplar BMU Works tarafından oluşturulur.
 * Bu sayfa info mesajı gösterir ve giriş sayfasına yönlendirme sunar.
 */
import { Link } from 'wouter';
import { Header } from '../components/Header.js';
import { Alert, Card } from '../components/ui.js';

export function ManagerSignupPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="mx-auto max-w-md px-6 py-12">
        <Card>
          <h1 className="text-2xl font-bold text-slate-900">
            Hesap Kurulumu
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            BMU SkillProbe hesapları BMU Works ekibi tarafından kurulur.
            Hesabınızın açılması için bizimle iletişime geçin.
          </p>

          <div className="mt-6">
            <Alert variant="info">
              Demo talep etmek veya pilot kullanım için:{' '}
              <a
                href="mailto:info@bmuworks.com?subject=BMU%20SkillProbe%20Hesap%20Talebi"
                className="font-medium text-blue-900 underline"
              >
                info@bmuworks.com
              </a>
            </Alert>
          </div>

          <div className="mt-6 space-y-3 text-sm">
            <Link
              href="/yonetici/giris"
              className="block rounded-lg bg-blue-900 px-4 py-3 text-center font-medium text-white hover:bg-blue-800"
            >
              Yönetici Girişi
            </Link>
            <Link
              href="/demo"
              className="block rounded-lg border-2 border-blue-900 px-4 py-3 text-center font-medium text-blue-900 hover:bg-blue-50"
            >
              Hızlı Deneme (5 Soru)
            </Link>
            <Link
              href="/"
              className="block text-center text-slate-600 hover:text-blue-900"
            >
              ← Ana Sayfa
            </Link>
          </div>
        </Card>
      </main>
    </div>
  );
}
